import { FC } from 'react';

type ContactInfoAnswerProps = {
    answer: Array<{
        name: string;
        email: string;
    }>;
};
const ContactInfoAnswer: FC<ContactInfoAnswerProps> = ({ answer }) => {
    if (typeof answer.map !== 'function') {
        return <div>{JSON.stringify(answer)}</div>;
    }

    return (
        <div>
            {answer.map((contact, idx) => (
                <div key={idx}>
                    {contact.name} ({contact.email})
                </div>
            ))}
        </div>
    );
};
export default ContactInfoAnswer;
